// extracted by mini-css-extract-plugin
var _1 = "TermsAndConditions_disclaimer__kYpc0";
var _2 = "TermsAndConditions_pactSafeContainer__mFKMY";
var _3 = "TermsAndConditions_shippingDisclaimer__f1Svs";
var _4 = "TermsAndConditions_termsAndConditions__NQZXx";
var _5 = "TermsAndConditions_termsAndConditionsWrapper__XkIUX";
export { _1 as "disclaimer", _2 as "pactSafeContainer", _3 as "shippingDisclaimer", _4 as "termsAndConditions", _5 as "termsAndConditionsWrapper" }
